var api = require("!../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../node_modules/@teamsupercell/typings-for-css-modules-loader/src/index.js!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[2]!../../../../node_modules/postcss-loader/src/index.js!./extendedDropdown.module.css");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};